export const getCDNUrl = (asset) => {
  // if we have a CDN URL, use it
  if (process.env.REACT_APP_CDN_URL !== "undefined") {
    // Get the filename from the asset path
    const filename = asset.split('/').pop();
    return `${process.env.REACT_APP_CDN_URL}/static/media/${filename}`;
  }

  // If no CDN URL, return the original asset
  return asset;
}; 